interface Props {
  readonly size?: number;
}

export default function SuccessIcon(props: Props) {
  const { size = 19 } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 0a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19Zm5.155 5.625a1 1 0 0 0-1.41.1l-4.759 5.486-2.833-2.442a1 1 0 1 0-1.306 1.515l3.589 3.093a1 1 0 0 0 1.408-.102l5.411-6.24a1 1 0 0 0-.1-1.41Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
